import type { Provider } from '@angular/core';
import { ErrorHandler } from '@angular/core';

import { GlobalErrorHandler } from './global-error-handler';

/** Reemplaza el ErrorHandler default por el global de la app. */
export function provideGlobalErrorHandler(): Provider {
  return { provide: ErrorHandler, useClass: GlobalErrorHandler };
}
